import { render, staticRenderFns } from "./PurchasedGSCapitialComponent.vue?vue&type=template&id=36f74221"
import script from "./PurchasedGSCapitialComponent.vue?vue&type=script&lang=js"
export * from "./PurchasedGSCapitialComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports